module.exports = __webpack_public_path__ + "images/emoji/pound.a9d20fd39c59fb00fe98.png";